<template>
  <site-link
    :to="$search({ iconCollections: ['brands'] })"
    class="card horizontal inverted with-top-tag margin-bottom-0"
    style="max-height: var(--spacing-8xl); overflow: hidden"
  >
    <div
      class="section text-left margin-top-0 padding-top-0 padding-bottom-2xs"
      style="max-width: 14rem"
    >
      <h4
        class="text-uppercase size-md"
        style="letter-spacing: var(--letter-spacing-3xl); font-weight: 700"
      >
        Brands
      </h4>
      <p
        class="margin-0 size-sm"
        style="font-weight: 400"
      >
        The easiest way to add social logos to your site.
      </p>
    </div>
    <div
      class="header padding-bottom-sm"
      style="clip-path: polygon(0% 0, 100% 0%, 1000% 100%, 30px 100%)"
    >
      <div style="margin-top: -3.5rem">
        <div
          v-for="(iconRow, rowIndex) in [cardIconsRowOne, cardIconsRowTwo, cardIconsRowThree]"
          :key="rowIndex"
          class="size-xl display-flex flex-content-around margin-y-md"
        >
          <span
            v-for="(icon, iconIndex) in iconRow"
            :key="iconIndex"
          >
            <font-awesome-icon
              :icon="getIconString('brands', icon)"
            />
          </span>
        </div>
      </div>
    </div>
  </site-link>
</template>

<script>
  import { getIconString } from './styleCardData.js'

  export default {
    name: 'StyleCardBrands',

    data() {
      return {
        cardIconsRowOne: ['faTiktok', 'faGithub', 'faMailchimp', 'faSnapchat', 'faFigma', 'faVuejs', 'faVimeo', 'faFontAwesome'],
        cardIconsRowTwo: ['faFacebook', 'faGoogle', 'faApple', 'faSlack', 'faTwitch', 'faDiscord', 'faYoutube', 'faWordpress'],
        cardIconsRowThree: ['faTwitter', 'faLinkedin', 'faDropbox', 'faPaypal', 'faAlgolia', 'faSpotify', 'faInstagram', 'faDocker']
      }
    },

    methods: {
      getIconString
    }
  }
</script>
